/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import * as actionsAdvertManage from './action'
import * as actionsHome from '../Home/action'
import { Spin } from 'antd'
import Layout from './component/layout'
import './style.css'
const actions = Object.assign({}, actionsAdvertManage, actionsHome)

class AdvertManageList extends React.Component {
  static defaultProps = {
    clubTable: [],
    timePrice: [],
    tableType: [],
    totalType: [],
    tableInfo: {},
    walletType: [],
    qrcode: {},
  }
  state = {
    loading: true,
  }

  componentDidMount() {
    this.props.fetchClubList()
    this.props.fetchAdvertList(0).then((res) => {
      this.setState({ loading: false })
    })
    this.props.fetchAdvertSetting(0)
  }

  render() {
    const { advertList, advertSettingData } = this.props
    return (
      <div>
        {this.state.loading ? (
          <Spin
            tip="正在加载..."
            className="level-loading"
            style={{ textAlign: 'center' }}
          />
        ) : (
          <Layout
            fetchAdvertList={this.props.fetchAdvertList}
            clubList={this.props.clubList}
            advertList={advertList}
            advertSetting={this.props.advertSetting}
            advertSettingData={advertSettingData}
            updateOrder={this.props.updateOrder}
            searchData={this.props.searchData}
            stopAd={this.props.stopAd}
            displayAd={this.props.displayAd}
            delAd={this.props.delAd}
            updateAd={this.props.updateAd}
            fetchAdvertSetting={this.props.fetchAdvertSetting}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    clubList: state.getHome.clubList,
    advertList: state.getAdvertManage.advertList,
    advertSettingData: state.getAdvertManage.advertSetting,
  }
}
export default withRouter(connect(mapStateToProps, actions)(AdvertManageList))



// WEBPACK FOOTER //
// ./src/containers/AdvertManage/index.js